import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreederService } from 'src/app/services/breeder.service';
import { stringify } from 'querystring';
import { SaveInformationPostModel } from 'src/app/classes/save-information-post-model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register-breeder',
  templateUrl: './register-breeder.component.html',
  styleUrls: ['./register-breeder.component.scss']
})
export class RegisterBreederComponent implements OnInit {
  public saveInformationPostModel = new SaveInformationPostModel();

  public submitted = false;
  public succeed = false;
  public email: string;
  public firstname: string;
  public lastname: string;
  public kennelname: string;
  public termsagreed: boolean;

  private _token: string;

  constructor(private _breederService: BreederService, private _route: ActivatedRoute, private _router: Router, private _toastrService: ToastrService) { }

  ngOnInit() {
    this._token = this._route.snapshot.queryParams.token;
    this.email = this._route.snapshot.queryParams.email;
  }

  public onSubmit() {
    this.submitted = true;
    this.saveInformationPostModel.email = this.email;
    this.saveInformationPostModel.firstname = this.firstname;
    this.saveInformationPostModel.lastname = this.lastname;
    this.saveInformationPostModel.kennelname = this.kennelname;

    this._breederService.saveRegisterInformation(this.saveInformationPostModel).subscribe(result => {
      if(result){
        this._router.navigate(['activate-user'], { queryParams: {token:result.token}});
        return;
      }
      this._router.navigate(['login']);
    },
    s => {
      if(s.status == '409'){
        console.log(s);
        this.submitted = false;
        this._toastrService.error('Dit e-mailadres kan niet gebruikt worden.');
      }
    });
  }
}
